export default __webpack_public_path__ + "assets/images/8.2ee284.png";